<template>
  <section class="scrollable padder">
    <div v-if="loading" class="loading">Loading&#8230;</div>
    
    <section class="panel panel-default">
     
      <div class="modal-body">
        <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addEdit)" method="post">
          <div class="row">  
          <div class="col-md-6">
             <ValidationProvider
               name="Site Name"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="site-name">
                Site Name <span class="required-color">*</span></label
              >
              <input
                class="form-control"
                type="text"
                id="site-name"
                v-model="siteName"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid name"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Site Name"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
          
                </ValidationProvider>
          </div>
              <div class="col-md-6">
                <ValidationProvider name="Project" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Project</label>
                  <select
                    class="form-control"
                    v-model="projectId"
                    name="project"
                    style="width: 100%;"
                  >
                    <option id="term" selected value=""
                      >Choose Project</option
                    >
                    <option
                      v-for="project in projectList"
                      :key="project.project_id"
                      v-bind:value="project.project_id"
                      >{{ project.project_name }}</option
                    >
                  </select>
                   <span style="color:red">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              </div>
              <div class="col-md-6">
                <ValidationProvider name="Site Engineer" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Site Engineer</label>
                 <input
                type="text"
                class="form-control"
                id="contact-person"
                v-model="siteEngineer"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid name"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Site Engineer"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-6">
                <ValidationProvider name="Site Supervisor" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Site Supervisor</label>
                 <input
                type="text"
                class="form-control"
                id="site-supervisor"
                v-model="siteSupervisor"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid name"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Site Supervisor"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
          <div class="col-sm-12">
             <ValidationProvider
               name="Site Address"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="address">
                Address <span class="required-color">*</span></label
              >
              <input
                class="form-control"
                type="text"
                id="address"
                v-model="siteAddress"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid address"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Customer Address"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
          
                </ValidationProvider>
          </div>
          <!--
              <div class="col-md-4">
                <ValidationProvider name="city" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> City</label>
                 <input
                type="text"
                class="form-control"
                id="city"
                v-model="siteCity"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid city anme"
                data-parsley-trigger="keyup"
                value=""
                placeholder="City"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-4">
                <ValidationProvider name="PO Box" rules="" v-slot="{ errors }">
                <div class="form-group">
                  <label> P.O Box</label>
                 <input
                type="text"
                class="form-control"
                id="poBox"
                v-model="sitePO"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid P.O Box number"
                data-parsley-trigger="keyup"
                value=""
                placeholder="P.O Box"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-4">
                <ValidationProvider name="payment-term" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Country</label>
                  <select
                    class="form-control"
                    v-model="siteCountry"
                    name="payment_term"
                    style="width: 100%;"
                  >
                    <option id="term" selected value=""
                      >Choose Country</option
                    >
                    <option
                      v-for="country in countryList"
                      :key="country"
                      v-bind:value="country"
                      >{{ country }}</option
                    >
                  </select>
                   <span style="color:red">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              </div>
            -->
              <div class="col-md-6">
                <ValidationProvider name="phone" rules="" v-slot="{ errors }">
                <div class="form-group">
                  <label> Phone</label>
                 <input
                type="text"
                id="phone"
                class="form-control"
                v-model="sitePhone"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid phone number"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Phone"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-6">
                <ValidationProvider name="mobile" rules="" v-slot="{ errors }">
                <div class="form-group">
                  <label> Mobile</label>
                 <input
                type="text"
                class="form-control"
                id="mobile"
                v-model="siteMobile"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid mobile number"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Mobile"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
          </div>
          <div class="modal-footer" style="text-align: right">
           
            <button
              :disabled="saveCat"
              id="btn_save"
              type="submit"
              class="btn btn-success  text-center  "
            >
              Save
            </button>
             <a
              v-on:click="$emit('hide-form')"
              class="btn btn-danger  text-center  "
            >
              Close
            </a>
          </div>
        </form>
        </ValidationObserver>
      </div>
      
    </section>
  </section>
</template>

<script>
import api from "../api";
import config from '../config'

export default {
  props: ["siteId"],
  name: "AddSite",
  data() {
    return {
      saveCat: false,
      itemId: '',
      projectId: '',
      siteName: '',
      siteSupervisor: '',
      siteEngineer: '',
      siteAddress: '',
      countryList: config.countryList,
      siteCity: '',
      sitePO: '',
      siteCountry: '',
      sitePhone: '',
      siteMobile: '',
      errors : [],
      projectList: [],
      loading: false,
    };
  },
  methods: {
    getProject: function() {
      const list = {filter: {}};
      api
        .request("post", "GeneralApis/get_projects", list)
        .then((response) => {
          var data = response.data;
          if (data.errorcode) {
            this.projectList = response.data.values;
          } else {
            this.projectList = data.projectList;
          }
        });
    },
    addEdit() {
       this.loading = false
      this.saveCat = true;
      this.itemId = this.$props.siteId;
      this.errors = []
      if (!this.siteName) {
        this.errors.push("Site Name is required.");
      }
      if(!this.errors.length){
      const addItem = {
        "site-form": {
          site_id: this.itemId,
          project_id: this.projectId,
          site_name: this.siteName,
          site_engineer: this.siteEngineer,
          site_supervisor: this.siteSupervisor,
          site_city: this.siteCity,
          site_po: this.sitePO,
          site_country: this.siteCountry,
          site_phone: this.sitePhone,
          site_mobile: this.siteMobile,
          site_address: this.siteAddress
        },
      };
      if (this.itemId > 0) {
        api
          .request("post", "GeneralApis/edit_site", addItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Updated");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      } else {
        api
          .request("post", "GeneralApis/add_site", addItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Added");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      }
      }
    },
    getSite: function() {
      var site_id = this.$props.siteId;
        (this.siteName = ""),
        (this.projectId = ""),
        (this.siteEngineer = ""),
        (this.siteSupervisor = ""),
        (this.siteCity = ""),
        (this.sitePO = ""),
        (this.siteCountry = ""),
        (this.siteMobile = ""),
        (this.siteAddress = ""),
        (this.sitePhone = ""),
        (this.itemId = 0);
      if (site_id > 0) {
        this.itemId = site_id;

        const getItem = {
          filter: {
            site_id: this.itemId,
          },
        };
        api
          .request("post", "GeneralApis/get_sites", getItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              const siteList = data.siteList[0];
              this.siteName = siteList.site_name;
              this.siteAddress = siteList.site_address;
              this.sitePhone = siteList.site_phone;
              this.siteEngineer = siteList.site_engineer;
              this.siteSupervisor = siteList.site_supervisor;
              this.siteCity = siteList.site_city;
              this.sitePO = siteList.site_po;
              this.siteCountry = siteList.site_country;
              this.sitePhone = siteList.site_phone;
              this.siteMobile = siteList.site_mobile;
              this.projectId = siteList.project_id;
            }
          });
      }
    },
  },
  mounted() {
    this.getProject();
    this.getSite();
  },
};
</script>
